import React from 'react';
import Options from '../dashboard/partials/options';
import fakeAuth from '../../../fakeAuth';
import Card from './partials/card';
import Gear from '../../partials/gear';
import { Link } from 'react-router';
import moment from 'moment';
import _ from 'lodash';

class Tournaments extends React.Component {
    state = {
        tournaments: null,
        microTransac: false
    }
    componentWillMount() {
        const { tournaments, tournamentsActions } = this.props;
        if (!tournaments) this.setState({ microTransac: true }, () => {
            tournamentsActions && tournamentsActions.fetch();
        });
        else this.setState({ tournaments });
    }
    componentWillReceiveProps = nextProps => {
        const { tournaments } = nextProps;
        this.setState({ tournaments, microTransac: false });
    }
    logout = () => {
        fakeAuth.signout(() => {
            this.props.router.push('/admin');
        });
    }
    render() {
        const { microTransac, tournaments = [] } = this.state;
        const ordered = _.filter(tournaments, t => moment(t.DateEnd).utc().isAfter(moment())),
            past = _.filter(tournaments, t => moment(t.DateEnd).utc().isBefore(moment()));
            console.log({ first: _.first(past) });
        return (
            <section className="d-flex flex-column h-100">
                <div className="d-flex flex-row p-4">
                    <Link to="/admin/dashboard" className="align-self-center idented d-flex flex-row white font-16">
                        <i className="fas fa-arrow-left margin-right align-self-center" />
                        <span className="anton align-self-center">BACK</span>
                    </Link>
                    {microTransac && <Gear className="ml-auto" />}
                    <h1 className="anton ml-auto align-self-center no-margin no-padding text-right white padding-right">TOURNAMENTS</h1>
                </div>
                <div className="h-100" style={{ position: 'relative' }}>
                    <section id="left" style={{ position: "absolute", top: 0, bottom: 0, left: 0, width: 200 }} className="">
                        <Options current={1} onLogout={this.logout} />
                    </section>
                    <section id="left" style={{ position: "absolute", overflowY: 'auto', top: 0, bottom: 0, left: 200, right: 0 }} className="clearfix">
                        <div className="clearfix">
                        <Link to="/admin/tournaments/add" style={{ float: 'left' }}>
                            <figure className="card p-4 margin-right d-flex flex-column justify-content-center pointer hover-red bg-danger" style={{ width: 250, height: 280 }}>
                                <i className="fa fa-plus font-50 align-self-center white" />
                                <span className="align-self-center margin-top-half font-14 white">Add Tournament</span>
                            </figure>
                        </Link>

                        {tournaments && ordered.map((tournament, index) => <Card tournament={tournament} key={index} index={index} />)}
                        </div>

{ tournaments && <h1 className="mt-4 anton white padding-right">PAST TOURNAMENTS</h1>}
                        <div className="clearfix">
                        {tournaments && past.map((tournament, index) => <Card tournament={tournament} key={index} index={index} />)}
                        </div>

                    </section>
                    
                </div>
            </section>
        )
    }
}

export default Tournaments;



// WEBPACK FOOTER //
// ./src/components/private/tournaments/index.js